import React, { FC, ReactNode } from "react";
import { PdUIKitProvider } from "@pd/pd-ui-kit";

interface IProps {
  children: ReactNode;
}

const DirectoryProvider: FC<IProps> = ({ children }) => (
  <PdUIKitProvider>{children}</PdUIKitProvider>
);

export default DirectoryProvider;
